import { OvertimeRequest } from "@/types"
import { supabase } from "@/integrations/supabase/client"
import { OvertimeStatus } from "@/types/enums"
;

/**
 * Hook for overtime approval functionality
 */
export const useApprovals = (
  user: { id: string; name?: string } | null,
  setOvertimeRequests: React.Dispatch<React.SetStateAction<OvertimeRequest[]>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<string | null>>
  ) => {
  
  const approveOvertimeRequest = async (requestId: string, reason: string): Promise<boolean> => {
    setLoading(true)
    setError(null)
    
    try {
      const updateData = {
        status: OvertimeStatus.APPROVED, 
        approver_comment: reason,
        approver_id: user?.id,
        approver_name: user?.name,
        updated_at: new Date().toISOString()
      } as any
      
      const { error } = await (supabase as any)
        .from('overtime_requests')
        .update(updateData)
        .eq('id', requestId)
      
      if (error) throw error
      
      setOvertimeRequests(prevRequests =>
        prevRequests.map(req =>
          req.id === requestId ? { 
            ...req, 
            status: OvertimeStatus.APPROVED, 
            approverComment: reason,
            approverId: user?.id,
            approverName: user?.name,
            updatedAt: new Date().toISOString()
          } : req
        )
      )
      
      return true
      
    } catch {
      setError("Failed to approve overtime request")
      return false
    } finally {
      setLoading(false)
    }
  }

  const approveOvertimeRequestAsVP = async (requestId: string, reason: string): Promise<boolean> => {
    return approveOvertimeRequest(requestId, reason);
  }
  
  const rejectOvertimeRequest = async (requestId: string, reason: string): Promise<boolean> => {
    setLoading(true)
    setError(null)
    
    try {
      const updateData = {
        status: OvertimeStatus.REJECTED, 
        approver_comment: reason,
        approver_id: user?.id,
        approver_name: user?.name,
        updated_at: new Date().toISOString()
      } as any
      
      const { error } = await (supabase as any)
        .from('overtime_requests')
        .update(updateData)
        .eq('id', requestId)
      
      if (error) throw error
      
      setOvertimeRequests(prevRequests =>
        prevRequests.map(req =>
          req.id === requestId ? { 
            ...req, 
            status: OvertimeStatus.REJECTED, 
            approverComment: reason,
            approverId: user?.id,
            approverName: user?.name,
            updatedAt: new Date().toISOString()
          } : req
        )
      )
      
      return true
      
    } catch {
      setError("Failed to reject overtime request")
      return false
    } finally {
      setLoading(false)
    }
  }
  
  return {
    approveOvertimeRequest,
    approveOvertimeRequestAsVP,
    rejectOvertimeRequest
  }
}
